module.exports = __webpack_public_path__ + "img/eye.a7238729.svg";